export function TawzeefLogo({ light = false, compact = false }: { light?: boolean; compact?: boolean }) {
  return <span className={`tawzeef-logo ${light ? "tawzeef-logo--light" : ""} ${compact ? "tawzeef-logo--compact" : ""}`}>
    <img
      decoding="async"
      fetchPriority="high"
      width="190"
      height="62"
      alt="Tawzeef"
      className="tawzeef-logo__artwork"
      src="/tawzeef-logo.svg?v=5"
    />
    {compact ? null : <small>Admin operations</small>}
  </span>;
}
